<template>
    <div class="content-wrapper">
        <span class='header-icon' uk-icon="icon: user; ratio: 6"></span><h1>{{profile.first_name}} {{profile.last_name}}</h1>

        <div v-for="(item, i) in processedFields" :key="i" class="uk-flex uk-flex-left">
            <div class="relative">
                <h2 class="uk-margin-large-right">{{item.data_name}}: {{item.data }}</h2>
                <sup @click="updateEditState(i)" class="edit-btn">{{ item.action }}</sup>
            </div>
            <div class="uk-flex" v-if="item.showInput">
                <input :value="item.data" class="uk-input" type="text" /><sup><button @click="cancelUpdate(i)" style="margin: 5px" class="uk-button uk-button-small">Cancel</button></sup>
            </div>
        </div>
        <div v-if="updateOpen > 1" class="uk-flex uk-flex-left">
            <button @click="updateAll" class="uk-button uk-button-primary uk-button-large uk-width-1-4 min-width">Update All</button>
        </div>
    </div>

</template>

<script>
    export default {
        name: "profile",
        props: {
            profileData :{
                type: Object,
                default: function(){
                    return {
                        profile:this.$store.state.user.data,
                        user:this.$store.state.user.data.user
                    }
                }
            },
            dataKeys: {
                type: Array,
                default: function(){
                    return ['first_name', 'last_name', 'email', 'phone', 'position_type',  'bio']
                }
            },
            translationKey: {
                type: Object,
                default: function(){
                    return {
                        'first_name':'First Name',
                        'last_name':'Last Name',
                        'email':'Email',
                        'phone':'Phone',
                        'position_type':'Position Type',
                        'bio':'Bio'}
                }
            },
        },
        data: function() {
            return {
                profile: this.$store.state.user.data,
                action: 'edit',
                numFields: this.dataKeys.length,
                processedFields : [],
                workingValues: [],
                updateOpen:0
            }
        },
        created(){
            this.processedFields = this.dataKeys.reduce((acc, cv, i,a) => {
                    if(this.profileData.profile.hasOwnProperty(String(cv))){
                        acc.push({
                            "index": i,
                            data:this.profileData.profile[cv],
                            data_name:this.translationKey[cv],
                            showInput: false,
                            action:'edit'})
                    } else if(this.profileData.user.hasOwnProperty(String(cv))){
                        acc.push({
                            "index": i,
                            data:this.profileData.user[cv],
                            data_name:this.translationKey[cv],
                            showInput: false,
                            action:'edit'})
                    } else {
                        console.warn(`does not have property ${cv}; no key ${cv}; profile.${cv} is undefined`)
                        acc.push({
                            "index":i,
                            data:"",
                            data_name:this.translationKey[cv],
                            showInput: false,
                            action:'edit'})
                    }
                    return acc
                }, [])
        // console.log(this.profileData)
        },
        methods: {
            updateEditState(i){
                if(this.processedFields[i].action === "edit"){
                   this.initializeUpdate(i)
                } else {
                    if(this.confirmUpdate()){
                        console.log('checking to see if we need to update or cancel if no change, then we can send')
                    } else {
                        this.uninitializeUpdate(i)
                    }
                }
            },
            initializeUpdate(i){
                this.updateOpen++;
                this.processedFields[i].showInput = true;
                this.processedFields[i].action = "update";
                this.workingValues.push(this.processedFields[i])
            },
            uninitializeUpdate(i){
                this.updateOpen--;
                this.processedFields[i].showInput = false;
                this.processedFields[i].action = "edit";
            },
            cancelUpdate(i){
                this.processedFields[i].showInput = false;
                this.processedFields[i].action = "edit";
                this.updateOpen--;
            },
            confirmUpdate(){
                let res = confirm('Confirm Update')
                if(res){
                    return true
                }
                else false
            },
            updateAll(){
                this.workingValues.forEach(v => this.cancelUpdate(v.index))
            }
        }
    }
</script>

<style lang="less" scoped>
    .edit-btn {
        position: absolute;
        top: 0px;
        right: 20px;
        margin: 0;
    }

    .relative {
        position: relative;
    }
    .min-width {
        min-width: 167px;
    }
</style>
